import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom"
import './rsbutton.css'
import refImg from "../../assets/img/society.png"
const ActionRefferal = ({to, onClick, children}) => {
  return (
    <Link
      to={to}
      className={`btn btn-edit`}
      onClick={onClick}
    >
      <img src={refImg} style={{width:36}} /> {children}
    </Link>
  );
};

ActionRefferal.propTypes = {
to:PropTypes.string,
onClick: PropTypes.func,
children: PropTypes.string,
};
ActionRefferal.defaultProps = {
    to:'#',
    onClick: () => {},
    children:''
  };
export default ActionRefferal;
